<template>
  <div class="modal-card">
    <CloseIcon :size="24" class="close-modal-icon close-on-click" />
    <div class="modal-card-header">
      <h1 class="title">Deactivate Product</h1>
      <p class="subtitle">Are you sure you want to deactivate this product? Deactivating this product means it cannot be selected when creating or editing tickets. Existing tickets that reference this product are not affected, and the product can be reactivated later.</p>
    </div>
      <div v-if="error" class="modal-error">
        {{ error }}
      </div>
    <div class="modal-card-footer">
      <button class="button danger form-button" @click="handleConfirm" :disabled="isSubmitting">
        {{ isSubmitting ? 'Deactivating...' : 'Deactivate Product' }}
      </button>
    </div>
  </div>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue';
import * as api from '@/api';

export default {
  name: "DeleteProductModal",
  props: {
    productId: {
      type: [Number, String],
      required: true
    }
  },
  emits: ['close', 'deleted'],
  data() {
    return {
      isSubmitting: false,
      error: null
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    async handleConfirm() {
      this.error = null;
      this.isSubmitting = true;

      try {
        await api.deleteProduct(this.productId);
        this.$emit('deleted');
      } catch (err) {
        this.error = err.message || 'Failed to deactivate product';
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  components: { CloseIcon }
};
</script>

<style scoped>
.modal-card {
  max-width: 450px;
}

.title {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 8px 0 0 0;
}

.modal-card-body {
  margin-top: 20px;
}

.warning-box {
  display: flex;
  gap: 12px;
  padding: 16px;
  background-color: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: var(--border-radius);
}

.warning-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background-color: #f59e0b;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
}

.warning-text {
  font-size: 14px;
  color: #92400e;
  line-height: 1.5;
}

.button.danger {
  background-color: #dc2626;
  color: #fff;
  border-color: #dc2626;
  box-shadow: 0 2px 0px #991b1b;
}

.button.danger:hover {
  background-color: #b91c1c;
  border-color: #b91c1c;
}

.button.danger:active {
  background-color: #991b1b;
  border-color: #991b1b;
}

.button.danger:disabled {
  background-color: #f3f4f6;
  color: #9ca3af;
  border-color: #d1d5db;
  box-shadow: none;
}
</style>
